import React, { useContext, useEffect, useState } from "react";
import { getChoresDiffrence, getDateHelper, getFrequencyDates, getFrequencyValue, getPriceHelper, isDateFinalized, setDateHelper, userDetails } from "../../utils/Helper";
import $ from 'jquery';
import useMakeRequest from "../../utils/ApiHelper";
import { ApiConstants } from "../../constants/ApiConstants";
import ReactSelect from "react-select";
import DatePicker from "react-datepicker";
import calLogo from '../../assets/images/calender.svg'
import Button from "../../components/ui/Button";
import { useForm } from "react-hook-form";
import moment from 'moment';
import { FREQUENCY_TYPES, HOUSEHOLD_TYPES } from "../../constants/Constants";
import { ErrorMessage } from "@hookform/error-message";
import { motion, AnimatePresence } from 'framer-motion';
import toast from "react-hot-toast";
import { yupResolver } from "@hookform/resolvers/yup";
import ValidationMessage from "../../constants/ValidationMessage";
import * as yup from 'yup';
import authContext from "../../context/authContext";

interface expensesFilterInputs {
    payer?: object; // Payer
};

const MarkAsPaid = ({ payers, expensesCategories, editExpense, onCancel, onSuccess, finalizedMonths }: any) => {

    let profile: any = useContext(authContext);
    profile = profile?.data;
    const updateExpense = useMakeRequest();

    console.log("editExpense: ", editExpense)

    const payerData = payers.filter((p: any) => p.label !== "Unpaid" && p.label !== "Joint Account")

    const { register, watch, setValue, getValues, formState: { errors }, handleSubmit, trigger, reset } = useForm<expensesFilterInputs>({
        mode: 'onChange',
        resolver: yupResolver(
            yup.object().shape({
                payer: yup
                    .object()
                    .nullable()
                    .required(ValidationMessage.SelectField("payer"))
                    .test(
                        'payer-required',
                        ValidationMessage.SelectField("payer"),
                        function (value: any) {
                            return value && value.value;
                        }
                    ),
            })
        ) as any
    });

    const onSubmit = (payload: any) => {
        const is_finalized = isDateFinalized(payload?.new_date, finalizedMonths || []);
        if (is_finalized) {
            toast.error("Selected date already finalized.")
            return;
        }

        const updatedArray = editExpense.map((item: any) => ({
            ...item,
            payer: payload?.payer?.value || item.payer,
            is_deleted: 0
        }));
        updateExpense.makeRequest({
            url: ApiConstants?.AllExpenseUpdate,
            payload: updatedArray
        })
    }

    useEffect(() => {
        if (updateExpense?.status) {
            onSuccess();
            $('.btn-close-modal').click()
            setTimeout(() => {
                toast.success('Expenses updated successfully.');
            }, 500);
        }
    }, [updateExpense?.status])

    return (

        <div className="modal fade bottom-sheet-modal" id="markAsPaidModal" tabIndex={-1} aria-labelledby="markAsPaidModalLabel" aria-hidden="true" data-bs-backdrop="true" data-bs-keyboard="true" >
            <div className="modal-dialog">
                <div className="modal-content">
                    {/* Bottom Sheet Handle */}
                    <div className="bottom-sheet-handle">
                        <div className="handle-bar"></div>
                    </div>

                    <div className="modal-header">
                        <h1 className="modal-title" id="markAsPaidModal">Mark as Paid</h1>
                    </div>

                    <div className="modal-body">
                        <form className="row gy-3" onSubmit={handleSubmit(onSubmit)}>
                            <div className="col-12 mb-5">
                                <div className="com-input-grp">
                                    <label className="form-label">Member</label>
                                    <div className='custom-select'>
                                        <ReactSelect
                                            value={watch('payer')}
                                            options={payerData}
                                            className="com-r-select"
                                            classNamePrefix="com-r-select"
                                            placeholder="Paid by"
                                            onChange={(selectedOption: any) => {
                                                setValue("payer", selectedOption);
                                                trigger("payer");
                                            }}
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}
                                            menuPortalTarget={document.body}
                                            styles={{
                                                menuPortal: base => ({ ...base, zIndex: 9999 })
                                            }}
                                        />
                                        <ErrorMessage
                                            errors={errors}
                                            name="payer"
                                            render={({ message }) => (
                                                <p className="error-message text-danger mt-1">{message}</p>
                                            )}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='d-flex gap-3 mt-4'>
                                <button className='custom-grayed-btn modal-light-btn mt-2 btn-close-modal' style={{ width: "50%" }} data-bs-dismiss="modal" aria-label="Close" disabled={updateExpense?.loading} type="button" onClick={onCancel}>Cancel</button>
                                <Button className='com-btn mt-2' type="submit" text="submit" style={{ width: "50%" }} loading={updateExpense?.loading}>Save</Button>
                            </div>
                        </form>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default MarkAsPaid